import { type SxProps, type Theme } from '@mui/material';

/**
 * Shallow-merges object `sx` values left to right, so a caller's keys win over a component's defaults.
 * Undefined sources are skipped. Function and array `sx` values aren't supported — pass objects.
 */
export default function mergeSx(...sources: Array<SxProps<Theme> | undefined>): SxProps<Theme> {
    return Object.assign({}, ...sources) as SxProps<Theme>;
}
